import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import { FC } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { getActiveStep } from '../../../../store/payroll/selectors';
import { payrollActions } from '../../../../store/payroll/slice';
import { TIntegrationFooter } from '../../type';

const IntegrationFooter: FC<TIntegrationFooter> = ({
  handleSubmit,
  isLoading,
  nextBtnText = 'saveChanges',
  isNextBtnDisabled = false,
  integrationName,
}) => {
  const { t } = useTranslation('common');
  const activeStep = useAppSelector(getActiveStep);
  const dispatch = useAppDispatch();

  const handleBack = () => {
    if (integrationName === 'ManageMate') {
      dispatch(payrollActions.setActiveStep(activeStep - 2));
    } else {
      dispatch(payrollActions.setActiveStep(activeStep - 1));
    }
  };

  return (
    <>
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box pr={1} pt={2} pb={1} justifyContent="flex-end" sx={{ display: 'flex', flexDirection: 'row' }}>
        <Button
          variant="outlined"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 2 }}
        >
          {t('back')}
        </Button>
        <LoadingButton
          onClick={handleSubmit}
          loading={isLoading}
          disabled={isNextBtnDisabled}
          variant="contained"
        >
          {t(`${nextBtnText}`)}
        </LoadingButton>
      </Box>
    </>
  );
};

export {
  IntegrationFooter,
};
